<template>
  <div v-if="loadComponent">
    <v-form>
      <v-container>
        <h1>Pag-Ibig</h1>
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="4" class="pb-0 mb-0">
            <v-text-field
              label="Code"
              :class="classPadding"
              v-model="pagibig.pagibigCode"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="8" class="pb-0 mb-0">
            <v-text-field
              label="Description"
              :class="classPadding"
              v-model="pagibig.pagibigDesc"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="3" md="3" class="pb-0 mb-0">
            <v-text-field
              label="Employee Percentage"
              :class="classPadding"
              v-model="pagibig.empPer"
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="3" md="3" class="pb-0 mb-0">
            <v-text-field
              label="Employer Percentage"
              :class="classPadding"
              v-model="pagibig.employerPer"
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="3" md="3" class="pb-0 mb-0">
            <v-text-field
              label="Employee Amount"
              :class="classPadding"
              v-model="pagibig.empAmt"
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="3" md="3" class="pb-0 mb-0">
            <v-text-field
              label="Employer Amount"
              :class="classPadding"
              v-model="pagibig.employerAmt"
              type="number"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
            <v-btn
              color="success"
              :loading="isSaving"
              :class="classPadding"
              @click.stop="save"
              v-if="userAccess.add >= 1"
              >Save</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </v-form>

    <v-container>
      <list :key="componentKey">
        <template slot="actions" slot-scope="{ item }">
          <v-btn @click.stop="edit(item)" text icon v-if="userAccess.edit >= 1">
            <v-icon color="primary">mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            @click.stop="deleteItem(item)"
            text
            icon
            v-if="userAccess.delete >= 1"
          >
            <v-icon color="error">mdi-delete</v-icon>
          </v-btn>
        </template>
      </list>
      <router-view />
    </v-container>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import List from "./List";
import userAccessMixin from "../../../../mixins/userAccessMixin";
const API_ENDPOINT = "/api/pagibig";
export default {
  metaInfo: {
    title: "Pag-Ibig",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  mixins: [userAccessMixin],
  components: {
    List
  },
  data: () => ({
    classPadding: "my-0 py-0",
    isSaving: false,
    pagibig: {},
    componentKey: 0
  }),
  methods: {
    ...mapActions("pagibig", ["selectPagibig"]),
    save() {
      this.isSaving = true;

      this.$axios
        .post(`${API_ENDPOINT}`, this.pagibig)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
    edit(item) {
      this.selectPagibig(Object.assign({}, item));
      this.$router.push(`/pagibig-setup/edit/${item.pagibigCode}`);
    },
    deleteItem(item) {
      this.$confirm(this.$deleteConfirm, {
        color: "error",
        title: "Delete"
      }).then(res => {
        if (res) {
          this.$axios
            .delete(`${API_ENDPOINT}/${item.pagibigCode}`)
            .then(({ data }) => {
              this.$toast.success(data.message);
              this.reset();
            })
            .catch(({ response }) => {
              this.$toast.error(response.data.message);
            });
        }
      });
    },
    reset() {
      this.pagibig = {};
      this.forceRerender();
    },
    forceRerender() {
      this.componentKey += 1;
    }
  },
  watch: {
    $route(val) {
      if (val.name === "pagibig-setup") {
        this.forceRerender();
      }
    }
  },
  created() {
    this.getUserAccessRights("PagIbig");
  }
};
</script>